export default __webpack_public_path__ + "867c42ae89e8d1ab5baedc34bfdd4fb9.png";